// Published details stay in place while the regular catalog controller starts.
// This entrypoint owns only the cancellable HTML bootstrap, never fish intent.
const page = document.getElementById("page");
const background = document.getElementById("fishydex-background");
const modal = document.getElementById("fishydex-details");
const lifecycle = new AbortController();
const rootUrl = new URL(page.dataset.fishydexBaseHref, location.href);

function dismissPublishedDetails(event) {
  if (event.type === "click") {
    if (!event.target.closest?.("[data-action='close-details']") || event.button > 0
      || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
  } else if (event.key !== "Escape") return;
  event.preventDefault();
  history.replaceState(null, "", rootUrl);
  page.dataset.fishydexSelectedItemId = "";
  modal.hidden = true;
  modal.classList.remove("fishydex-details-open");
  modal.setAttribute("aria-hidden", "true");
  background.inert = false;
  background.removeAttribute("aria-hidden");
}
modal.addEventListener("click", dismissPublishedDetails, { signal: lifecycle.signal });
document.addEventListener("keydown", dismissPublishedDetails, { signal: lifecycle.signal });
window.addEventListener("pagehide", () => lifecycle.abort(), { once: true, signal: lifecycle.signal });

// Paint the published images without waiting for the catalog API.
for (const [imageId, placeholderId, source] of [
  ["fishydex-details-icon", "fishydex-details-placeholder", page.dataset.fishydexIconImage],
  ["fishydex-details-guide-image", "fishydex-details-guide-placeholder", page.dataset.fishydexEncyclopediaIconImage],
]) {
  const image = document.getElementById(imageId);
  if (!image || !source) continue;
  image.addEventListener("load", () => {
    image.hidden = false;
    document.getElementById(placeholderId).hidden = true;
  }, { once: true, signal: lifecycle.signal });
  image.src = window.__fishystuffResolveCdnUrl(source);
}

async function bootstrap() {
  background.dataset.fishydexBackgroundState = "loading";
  try {
    if (rootUrl.origin !== location.origin) throw new Error("Fishydex root must be same-origin");
    const response = await fetch(rootUrl, {
      credentials: "same-origin", headers: { Accept: "text/html" }, signal: lifecycle.signal,
    });
    if (!response.ok || new URL(response.url).pathname !== rootUrl.pathname
      || new URL(response.url).origin !== rootUrl.origin
      || !response.headers.get("content-type")?.includes("text/html")) {
      throw new Error(`Invalid Fishydex root response (${response.status})`);
    }
    const root = new DOMParser().parseFromString(await response.text(), "text/html");
    const source = root.getElementById("fishydex-background");
    if (!source?.querySelector("fishydex-surface")) throw new Error("Missing Fishydex catalog surface");
    // Import before insertion: the controller observes the surface's one connection.
    await import("../contracts/fish-zone-evidence.js");
    await import("./fishydex.js");
    await import("../components/fishydex-surface.js");
    if (lifecycle.signal.aborted) return;
    page.dataset.fishydexRootTitle = root.title;
    if (!page.dataset.fishydexSelectedItemId) document.title = root.title;
    background.replaceChildren(...source.childNodes);
    background.dataset.fishydexBackgroundState = "ready";
    lifecycle.abort();
  } catch (error) {
    if (lifecycle.signal.aborted) return;
    background.dataset.fishydexBackgroundState = "unavailable";
    console.error("Fishydex catalog bootstrap failed", error);
  }
}
void bootstrap();
